import { render, staticRenderFns } from "./img-comp-del.vue?vue&type=template&id=38b75c22&scoped=true&"
import script from "./img-comp-del.vue?vue&type=script&lang=js&"
export * from "./img-comp-del.vue?vue&type=script&lang=js&"
import style0 from "./img-comp-del.vue?vue&type=style&index=0&id=38b75c22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b75c22",
  null
  
)

export default component.exports